import { combineReducers } from '@mode/legacy/util-domain';
import { StoreModule } from '@ngrx/store';
import { fromViewDataModal } from '~/ngrx-compat/viewDataModal';
import { activeExplorationReducers } from '~/reducers/active-exploration.reducers';
import { ClientReducer } from '~/reducers/client.reducers';
import { explorationsReducers } from '~/reducers/explorations.reducers';
import { PersistentReducer } from '~/reducers/persistent.reducers';
import { routerFeatureReducer } from '~/reducers/router.reducers';
import { sqlResultsReducers } from '~/reducers/sql-results.reducers';
import { TransientReducer } from '~/reducers/transient.reducers';
import { vizDesignerReducers } from '~/reducers/viz-designer.reducers';
import { workspaceReducers } from '~/reducers/workspace.reducers';

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const LEGACY_STORES = [
  StoreModule.forFeature('router', routerFeatureReducer),
  StoreModule.forFeature('client', combineReducers(ClientReducer)),
  StoreModule.forFeature('persistent', combineReducers(PersistentReducer)),
  StoreModule.forFeature('transient', combineReducers(TransientReducer)),
  StoreModule.forFeature('sqlResults', combineReducers(sqlResultsReducers)),
  StoreModule.forFeature('vizDesigner', combineReducers(vizDesignerReducers)),
  StoreModule.forFeature('activeExploration', combineReducers(activeExplorationReducers)),
  StoreModule.forFeature('workspace', combineReducers(workspaceReducers)),
  StoreModule.forFeature('explorations', combineReducers(explorationsReducers)),
  StoreModule.forFeature('viewDataModal', combineReducers(fromViewDataModal.viewDataModalReducers)),
];
